import type { FC } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { PrimaryButton } from 'src/presentation/components/molecules/Button';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import { SvgIconType } from '@thermenresorts/icons';
import Translations from 'src/core/utils/Translations';

interface Props {
	onPress: () => void;
}

const AddReservationCard: FC<Props> = (props) => {
	return (
		<View style={styles.card}>
			<Text style={styles.title}>{Translations.addReservationManually}</Text>
			<Text style={styles.description}>{Translations.addReservationManuallyDescription}</Text>
			<PrimaryButton
				backgroundColor={Colors.white}
				iconColor={Colors.black}
				iconSize={Dimens.iconSize12}
				label={Translations.enterManually}
				svgIcon={SvgIconType.plus}
				textColor={Colors.black}
				onPress={props.onPress}
			/>
		</View>
	);
};

const styles = StyleSheet.create({
	card: {
		flexDirection: 'column',
		marginBottom: Dimens.padding10,
		backgroundColor: Colors.sand,
		padding: Dimens.padding15,
		borderRadius: Dimens.borderRadius10,
	},
	title: {
		color: Colors.gray900,
		fontSize: Dimens.fontSize20,
		fontFamily: Fonts.ptSerif,
		textAlign: 'left',
		marginBottom: Dimens.padding8,
	},
	description: {
		color: Colors.gray900,
		fontSize: Dimens.fontSize14,
		textAlign: 'left',
		fontFamily: Fonts.ptSerif,
		marginBottom: Dimens.padding16,
	},
});

export default AddReservationCard;
